// extracted by mini-css-extract-plugin
module.exports = {"main":"job_opening_filter-module_main_65e72"};